import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const ContactWrapper = styled.div`

border-bottom: 1px solid ${themeGet('border.3', '#E6E6E6')};

@media (min-width: 950px) {
  margin: 30px 100px 0 100px;
}

@media (max-width: 950px) {
  margin: 30px 5px 0 5px;
}

  > h2 {
    color: ${themeGet('text.0', '#2C2C2C')};
    font-size: 25px;
    line-height: 30px;
    font-weight: 700;

    @media (max-width: 480px) {
      font-size: 17px;
      line-height: 21px;
    }
  }

  .container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
  }

  .row-cursor-pointer, .row-cursor-pointer td label {
    cursor: pointer !important;
  }
`;
export const FormContactWrapper = styled.div`
  margin : -30px 40px 0 -40px;
`;
export const FormWrapper = styled.div`
  
  width: 40%;

  padding: 10px; 
  #margin-left: 350px;
  margin: auto;
  @media (min-width: 1441px) {
    #padding: 130px;
  }
  @media (max-width: 1200px) {
    width: 50%;
  }
  @media (max-width: 991px) {
    padding: 56px;
    width: 80%;
    margin: 0 auto;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
  @media (max-width: 480px) {
    padding: 30px;
  }
`;

export const AdressDetail = styled.div`
  margin: 10px 0 0 0; 

  h3 {
    color: ${themeGet('text.0', '#2C2C2C')};
    font-size: 100px;
    line-height: 30px;
    font-weight: 700;
    font-size: 20px;
    margin-top: 20px;

    @media (max-width: 480px) {
      font-size: 15px;
      line-height: 15px;
      font-size: 20px;
    }
  }
  
  text {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;